<script setup lang="ts">
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import ClubReservePointModal from './ClubReservePointModal.vue';
import FormSidebar from './FormSidebar.vue';
import SvgCoin from '@files/Bilitcoin.svg?component';

import { VerificationStatus } from '@itinerary/Exceptions';

const { mobileOnly, desktopOnly } = defineProps<IProps>();
const formStore = useFormStore();
const invoiceStore = useInvoiceStore();
const { receivedScore } = classToRefs(invoiceStore);
interface IProps {
    mobileOnly?: boolean;
    desktopOnly?: boolean;
}
const { isMobile } = useSize();
const { open } = usePopOver({
    component: ClubReservePointModal,
    zIndex: 1001002,
});
const pointsText = computed(() => formatSeparator(receivedScore.value));
const isLoading = computed(
    () =>
        formStore.verificationStatus === VerificationStatus.None ||
        formStore.verificationStatus === VerificationStatus.Loading
);
const showSvg = computed(() => {
    if (desktopOnly) {
        return !isMobile.value;
    }
    if (mobileOnly) {
        return isMobile.value;
    }
    return true;
});
</script>

<template>
    <FormSidebar
        v-if="!isLoading && receivedScore"
        class="club-reserve-point-container"
        :class="{
            mobile: mobileOnly,
            desktop: desktopOnly,
        }"
        @click="open()"
    >
        <SvgCoin v-if="showSvg" />
        <div class="point">{{ pointsText }}</div>
        <div class="point-text">امتیاز دریافتی از این سفر</div>
        <mr-button
            :icon-button="{ icon: faChevronLeft, color: 'black' }"
            variant="transparent"
            size="small"
        />
    </FormSidebar>
</template>

<style lang="scss" scoped>
.mobile {
    @include desktop-only {
        display: none;
    }
}
.desktop {
    @include mobile-only {
        display: none;
    }
}
.club-reserve-point-container {
    align-items: center;
    height: 60px;
    cursor: pointer;
    .point {
        @include tg-l($w7);
        margin-inline: 4px;
    }

    .point-text {
        @include tg-l;
        margin-left: auto;
    }
    .modal {
        cursor: auto;
    }
}
</style>
